require("./artistsbyparent.panel");
require("./artistsinwebform.panel");
require("./germantaxoffice.panel");
require("./venuemap.dialog");
require("./webforms.panel");